// extracted by mini-css-extract-plugin
export default {"aboutSection":"SectionAbout_aboutSection__TPZQ2","title":"SectionAbout_title__dFjgS","circleWrapper":"SectionAbout_circleWrapper__yyotg"};